const DELIVERY_STATUS = {
    delivered: {
        label: '메일 서버 전달',
        description: '수신 메일 서버가 메시지를 수락했습니다. 실제 받은편지함 노출까지 보장하지는 않습니다.',
        color: 'success.main',
        backgroundColor: 'rgba(46, 125, 50, 0.08)',
    },
    bounced: {
        label: '반송',
        description: '수신 서버가 메일을 반송했습니다. 이메일 주소와 반송 사유를 확인하세요.',
        color: 'error.main',
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
    },
    complained: {
        label: '스팸 신고',
        description: '수신자 또는 메일 사업자로부터 신고 이벤트가 접수되었습니다.',
        color: 'error.main',
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
    },
    rejected: {
        label: 'SES 거부',
        description: 'SES가 메시지 처리를 거부했습니다. 발송 이력의 사유를 확인하세요.',
        color: 'error.main',
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
    },
    delayed: {
        label: '배송 지연',
        description: 'SES가 배송을 재시도하고 있거나 최종 결과를 기다리고 있습니다.',
        color: 'warning.main',
        backgroundColor: 'rgba(237, 108, 2, 0.08)',
    },
    rendering_failed: {
        label: '렌더링 실패',
        description: '메일 콘텐츠 생성 과정에서 오류가 발생했습니다.',
        color: 'error.main',
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
    },
}

export const getRecordMailStatus = ({ status, deliveryStatus } = {}) => {
    if (DELIVERY_STATUS[deliveryStatus]) {
        return DELIVERY_STATUS[deliveryStatus]
    }

    if (Number(status) === 1 || deliveryStatus === 'sent') {
        return {
            label: 'SES 접수',
            description: 'SES가 발송 요청을 접수했으며 아직 배송 결과 이벤트가 없습니다.',
            color: 'info.main',
            backgroundColor: 'rgba(2, 136, 209, 0.08)',
        }
    }

    return {
        label: '미접수',
        description: '아직 완주기록증 메일을 SES에 접수하지 않았습니다.',
        color: 'text.secondary',
        backgroundColor: '#f8fafc',
    }
}
